export enum ComponentCyTags {
  Slider = 'component-slider',
  SliderInput = 'component-slider-input',
  AmountInput = 'component-amount-input',
  AmountInputTokenSelectorItem = 'component-amount-input-token-selector-item',
  OrderbookAggregation = 'component-orderbook-aggregation',
  OrderbookAggregationItem = 'component-orderbook-aggregation-item',
  OrderbookLayoutOption = 'component-orderbook-layout-option',
  OrderbookMarkPrice = 'component-orderbook-mark-price',
  OrderbookRecordPrice = 'component-orderbook-record-price',
  OrderbookRecordQuantity = 'component-orderbook-record-quantity',
  OrderbookRecordTotal = 'component-orderbook-record-total',
  OrderbookRecordOrderIndicator = 'component-orderbook-record-order-indicator',
  OrderbookTradePrice = 'component-orderbook-trade-price',
  OrderbookTradeQuantity = 'component-orderbook-trade-quantity',
  OrderbookTradeTime = 'component-orderbook-trade-time',
  MarketSelectorTrigger = 'component-market-selector-trigger',
  MarketSelectorSearch = 'component-market-selector-search',
  MarketSelectorCategory = 'component-market-selector-category',
  MarketSelectorTable = 'component-market-selector-table',
  MarketSelectorRowFavorite = 'component-market-selector-row-favorite',
  MarketSelectorRowIndexPrice = 'component-market-selector-row-index-price',
  MarketSelectorRowChange = 'component-market-selector-row-change',
  MarketSelectorRowFundingRate = 'component-market-selector-row-funding-rate',
  MarketSelectorRowVolume = 'component-market-selector-row-volume',
  BuySellButtonTabs = 'component-buy-sell-button-tabs',
  BuySellButtonBuyPrice = 'component-buy-sell-button-buy-price',
  BuySellButtonSellPrice = 'component-buy-sell-button-sell-price',
  PositionsTable = 'component-positions-table',
  PositionsTableMarket = 'component-positions-table-market',
  PositionsTableContracts = 'component-positions-table-contracts',
  PositionsTableEntryPrice = 'component-positions-table-entry-price',
  PositionsTableMarkPrice = 'component-positions-table-mark-price',
  PositionsTablePnl = 'component-positions-table-pnl',
  PositionsTableTotalUsd = 'component-positions-table-total-usd',
  PositionsTableMargin = 'component-positions-table-margin',
  PositionsTableLiqPrice = 'component-positions-table-liq-price',
  PositionsTableFunding = 'component-positions-table-funding',
  PositionsTableTpSl = 'component-positions-table-tp-sl',
  PositionsTableClose = 'component-positions-table-close',
  OpenOrdersTable = 'component-open-orders-table',
  OpenOrdersTableMarket = 'component-open-orders-table-market',
  OpenOrdersTablePrice = 'component-open-orders-table-price',
  OpenOrdersTableAmount = 'component-open-orders-table-amount',
  OpenOrdersTableUnfilled = 'component-open-orders-table-unfilled',
  OpenOrdersTableFilled = 'component-open-orders-table-filled',
  OpenOrdersTableSide = 'component-open-orders-table-side',
  OpenOrdersTableType = 'component-open-orders-table-type',
  OpenOrdersTableTrigger = 'component-open-orders-table-trigger',
  OpenOrdersTableTotal = 'component-open-orders-table-total',
  OpenOrdersTableCancel = 'component-open-orders-table-cancel',
  TradeHistoryTable = 'component-trade-history-table',
  TradeHistoryTableMarket = 'component-trade-history-table-market',
  TradeHistoryTableTime = 'component-trade-history-table-time',
  TradeHistoryTablePrice = 'component-trade-history-table-price',
  TradeHistoryTableAmount = 'component-trade-history-table-amount',
  TradeHistoryTableFee = 'component-trade-history-table-fee',
  TradeHistoryTableType = 'component-trade-history-table-type',
  TradeHistoryTablePnl = 'component-trade-history-table-pnl',
  TradeHistoryTableTotal = 'component-trade-history-table-total',
  OrderHistoryTable = 'component-order-history-table',
  OrderHistoryTableMarket = 'component-order-history-table-market',
  OrderHistoryTableTimestamp = 'component-order-history-table-timestamp',
  OrderHistoryTablePrice = 'component-order-history-table-price',
  OrderHistoryTableAmount = 'component-order-history-table-amount',
  OrderHistoryTableSide = 'component-order-history-table-side',
  OrderHistoryTableType = 'component-order-history-table-type',
  OrderHistoryTableTrigger = 'component-order-history-table-trigger',
  OrderHistoryTableTotal = 'component-order-history-table-total',
  OrderHistoryTableStatus = 'component-order-history-table-status',
  FundingHistoryTable = 'component-funding-history-table',
  FundingHistoryTableTime = 'component-funding-history-table-time',
  FundingHistoryTablePair = 'component-funding-history-table-pair',
  FundingHistoryTablePayment = 'component-funding-history-table-payment',
  BalancesTable = 'component-balances-table',
  BalancesTableAvailable = 'component-balances-table-available',
  BalancesTableUsed = 'component-balances-table-used',
  BalancesTableTotal = 'component-balances-table-total',
  BalancesTableTotalUsd = 'component-balances-table-total-usd',
  DurationPicker = 'component-duration-picker'
}

export enum CommonCyTags {
  ToastCloseButton = 'toast-close-button',
  ToastCopyContextButton = 'toast-copy-context-button',
  ToastActionButton = 'toast-action-button',
  ToastViewOnInjScanLink = 'toast-view-on-injscan-link',
  ToastTitle = 'toast-title',
  ToastDescription = 'toast-description',
  ToastTimeElapsed = 'toast-time-elapsed',
  HeaderLogo = 'header-logo',
  HeaderNavigation = 'header-navigation',
  HeaderNavigationItem = 'header-navigation-item',
  HeaderWallet = 'header-wallet'
}

export enum TradeCyTags {
  MarketHeaderMarkPrice = 'market-header-mark-price',
  MarketHeaderIndexPrice = 'market-header-index-price',
  MarketHeaderChange24hUsd = 'market-header-change-24h-usd',
  MarketHeaderChange24hPercentage = 'market-header-change-24h-percentage',
  MarketHeaderVolume24h = 'market-header-volume-24h',
  MarketHeaderFundingRate = 'market-header-funding-rate',
  MarketHeaderFundingCountdown = 'market-header-funding-countdown',
  MarketSelector = 'trade-market-selector',
  TradeFormAmountSlider = 'trade-form-amount-slider',
  TradeFormLeverageButton = 'trade-form-leverage-button',
  TradeFormLeverageInput = 'trade-form-leverage-input',
  TradeFormLeverageSlider = 'trade-form-leverage-slider',
  TradeFormOrderTypeTabs = 'trade-form-order-type-tabs',
  TradeFormOrderTypeTab = 'trade-form-order-type-tab',
  TradeFormOrderTypeProDropdown = 'trade-form-order-type-pro-dropdown',
  TradeFormOrderTypeProItem = 'trade-form-order-type-pro-item',
  TradeFormTriggerPriceInput = 'trade-form-trigger-price-input',
  TradeFormAmountInput = 'trade-form-amount-input',
  TradeFormAmountTokenSelector = 'trade-form-amount-token-selector',
  TradeFormAvailableToTrade = 'trade-form-available-to-trade',
  TradeFormPositionSize = 'trade-form-position-size',
  TradeFormReduceOnlyCheckbox = 'trade-form-reduce-only-checkbox',
  TradeFormTpSlCheckbox = 'trade-form-tpsl-checkbox',
  TradeFormTpPriceInput = 'trade-form-tp-price-input',
  TradeFormTpChangeInput = 'trade-form-tp-change-input',
  TradeFormSlPriceInput = 'trade-form-sl-price-input',
  TradeFormSlChangeInput = 'trade-form-sl-change-input',
  TradeFormTpSlAdjust = 'trade-form-tpsl-adjust',
  TradeFormTpTriggerPrice = 'trade-form-tp-trigger-price',
  TradeFormSlTriggerPrice = 'trade-form-sl-trigger-price',
  TradeFormConnectWalletButton = 'trade-form-connect-wallet-button',
  TradeFormPlaceOrderButton = 'trade-form-place-order-button',
  TradeFormDetailsTotal = 'trade-form-details-total',
  TradeFormSlippage = 'trade-form-slippage',
  TradeFormEstSlippage = 'trade-form-est-slippage',
  TradeFormMaxSlippage = 'trade-form-max-slippage',
  TradeFormDetailsMargin = 'trade-form-details-margin',
  TradeFormDetailsLiquidationPrice = 'trade-form-details-liquidation-price',
  TradeFormDetailsFees = 'trade-form-details-fees',
  TradeFormMarginModeButton = 'trade-form-margin-mode-button',
  TradeFormLimitPriceInput = 'trade-form-limit-price-input',
  TradeFormLimitPriceMidButton = 'trade-form-limit-price-mid-button',
  TradeFormBuySellTabs = 'trade-form-buy-sell-tabs',
  TradeFormPostOnlyCheckbox = 'trade-form-post-only-checkbox',
  TradeFormBypassWarningCheckbox = 'trade-form-bypass-warning-checkbox',
  TradeFormEquityPerps = 'trade-form-equity-perps',
  TradeFormEquityUnrealizedPnl = 'trade-form-equity-unrealized-pnl',
  OrderbookSection = 'trade-orderbook-section',
  OrderbookToggler = 'trade-orderbook-toggler',
  ChartSection = 'trade-chart-section',
  ChartContainer = 'trade-chart-container',
  ChartElementsToggle = 'trade-chart-elements-toggle',
  ChartElementsToggleItem = 'trade-chart-elements-toggle-item',
  OrdersTabs = 'trade-orders-tabs',
  OrdersTab = 'trade-orders-tab'
}

export enum MarketsCyTags {
  OverviewRecentsSection = 'overview-recents-section',
  OverviewTopVolumeSection = 'overview-top-volume-section',
  OverviewTopGainersSection = 'overview-top-gainers-section',
  OverviewItem = 'overview-item',
  OverviewItemChange = 'overview-item-change',
  OverviewItemPrice = 'overview-item-price',
  OverviewItemVolume = 'overview-item-volume',
  MarketsExplorer = 'markets-explorer',
  LearnMoreItem = 'learn-more-item'
}

export enum PortfolioCyTags {
  ConnectButton = 'portfolio-connect-button',
  WithdrawButton = 'portfolio-withdraw-button',
  DepositButton = 'portfolio-deposit-button',
  HideBalancesButton = 'portfolio-hide-balances-button',
  ChartTabs = 'portfolio-chart-tabs',
  AccountBalance = 'portfolio-account-balance',
  BalanceChangeAmount = 'portfolio-balance-change-amount',
  PnlValue = 'portfolio-pnl-value',
  KeyStatsPnl = 'portfolio-key-stats-pnl',
  KeyStatsFeesSaved = 'portfolio-key-stats-fees-saved',
  KeyStatsVolume = 'portfolio-key-stats-volume',
  KeyStatsTotalEquity = 'portfolio-key-stats-total-equity',
  KeyStatsAvailableAssets = 'portfolio-key-stats-available-assets',
  KeyStatsUtilisedAssets = 'portfolio-key-stats-utilised-assets',
  BreakdownTradableBalance = 'portfolio-breakdown-tradable-balance',
  BreakdownCurrentPositions = 'portfolio-breakdown-current-positions',
  Chart = 'portfolio-chart'
}

export enum ModalCyTags {
  SlippageInput = 'modal-slippage-input',
  SlippageError = 'modal-slippage-error',
  SlippageWarning = 'modal-slippage-warning',
  SlippageCancelButton = 'modal-slippage-cancel-button',
  SlippageConfirmButton = 'modal-slippage-confirm-button',
  LeverageCancelButton = 'modal-leverage-cancel-button',
  LeverageConfirmButton = 'modal-leverage-confirm-button'
}
